import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ContactMethods} from '../../../../_models/contact-details.model';

@Component({
  selector: 'acabim-admin-add-email',
  templateUrl: './add-email.component.html',
  styleUrls: ['./add-email.component.scss']
})
export class AddEmailComponent implements OnInit {
  @Input() detailType: string = 'email';
  @Input() set existing(value: ContactMethods) {
    if (value) {
      this.existingDetails = value;
      this.initData();
      this.label = 'Update';
    }
  }
  @Output() submit = new EventEmitter<FormGroup>();

  addDataForm: FormGroup | null = null;
  addDataOptions = [
      {label: 'Work', value: 'work'},
      {label: 'Home', value: 'home'}
  ];
  existingDetails: ContactMethods | null = null;
  label = 'Add';

  constructor() { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    const baseValidator = this.detailType === 'email' ? Validators.email : Validators.minLength(8);
    this.addDataForm = new FormGroup({
      id: new FormControl(null),
      type: new FormControl({label: 'Work', value: 'work'}),
      detail: new FormControl('', [baseValidator]),
      isDefault: new FormControl(0),
      detailType: new FormControl(this.detailType)
    });
  }

  initData(): void {
    if (this.existingDetails && this.addDataForm) {
      const subtype = this.existingDetails.type ? {label: this.existingDetails.type, value: this.existingDetails.type.toLowerCase()} : {label: 'Work', value: 'work'};
      this.addDataForm.get('id')?.setValue(this.existingDetails.id);
      this.addDataForm.get('type')?.setValue(subtype);
      this.addDataForm.get('detail')?.setValue(this.existingDetails.value);
      this.addDataForm.get('isDefault')?.setValue(this.existingDetails.default);
    }
  }

  onAdd(): void {
    if(this.addDataForm) {
      this.submit.emit(this.addDataForm);
      this.initForm();
    }
  }
}
